/* Kit passo-a-passo — nativo no tema, sem app. (Lab77, 04/10/2026: trazido da Fábrica77.)
   1 un / Kit 2 / Kit 3 / Kit 5. Cada peça escolhe cor (produto irmão) e tamanho (variante).
   Monta /cart/add.js com N linhas; o desconto por quantidade é automático do Shopify. */
(function () {
  var raiz = document.querySelector('[data-kitw]');
  if (!raiz) return;

  var bruto = raiz.querySelector('[data-kitw-data]');
  var dados;
  try { dados = JSON.parse(bruto.textContent); } catch (e) { return; }
  if (!dados.cores || !dados.cores.length) return;

  var el = {
    painel: raiz.querySelector('[data-kitw-panel]'),
    passo: raiz.querySelector('[data-kitw-step]'),
    barra: raiz.querySelector('[data-kitw-bar]'),
    thumb: raiz.querySelector('[data-kitw-thumb]'),
    nome: raiz.querySelector('[data-kitw-name]'),
    unit: raiz.querySelector('[data-kitw-unit]'),
    cheio: raiz.querySelector('[data-kitw-full]'),
    pix: raiz.querySelector('[data-kitw-pix]'),
    corNome: raiz.querySelector('[data-kitw-cor-nome]'),
    cores: raiz.querySelector('[data-kitw-cores]'),
    tamanhos: raiz.querySelector('[data-kitw-tamanhos]'),
    resumo: raiz.querySelector('[data-kitw-resumo]'),
    proximo: raiz.querySelector('[data-kitw-next]'),
    erro: raiz.querySelector('[data-kitw-erro]')
  };

  var moeda = function (c) {
    return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  var estado = { qtd: 1, indice: 0, pecas: [], cor: null, tamanho: null };

  /* Cor da bolinha: usa a lista oficial do tema ("Preto: #000000").
     Cor sem hex na lista (ex.: swatch por imagem) cai na foto do produto. */
  var hexPorCor = {};
  (dados.swatchList || '').split('\n').forEach(function (linha) {
    var p = linha.split(':');
    if (p.length < 2) return;
    var valor = p.slice(1).join(':').trim();
    if (valor.charAt(0) === '#') hexPorCor[p[0].trim().toLowerCase()] = valor;
  });
  /* Lab77: na lista do tema o Branco e o Marrom Estonado apontam para imagem; aqui viram cor. */
  if (!hexPorCor['branco']) hexPorCor['branco'] = '#FFFFFF';
  if (!hexPorCor['marrom estonado']) hexPorCor['marrom estonado'] = '#6F4E37';

  /* Grade na ordem certa: PP, P, M, G, GG... e não na ordem do cadastro. */
  var ordem = dados.tamanhoOrdem || [];
  function ordenarTamanhos(lista) {
    return lista.slice().sort(function (a, b) {
      var ia = ordem.indexOf(String(a.nome).trim().toUpperCase());
      var ib = ordem.indexOf(String(b.nome).trim().toUpperCase());
      if (ia === -1) ia = 999;
      if (ib === -1) ib = 999;
      return ia - ib;
    });
  }
  /* Lab77: nome da cor vem ora "PRETO" ora "Preto" — mostra sempre "Preto". */
  function nomeBonito(t) {
    return String(t || '').toLowerCase().replace(/(^|\s)\S/g, function (m) { return m.toUpperCase(); });
  }
  dados.cores.forEach(function (c) { c.tamanhos = ordenarTamanhos(c.tamanhos); c.nome = nomeBonito(c.nome); });

  function faixa(qtd) {
    var t = dados.tiers.filter(function (x) { return x.qty <= qtd; });
    return t.length ? t[t.length - 1] : dados.tiers[0];
  }
  /* Lab77: cada cor pode ter preço próprio — o preço no kit é o preço DA PEÇA com o % da faixa. */
  function noKit(preco) {
    var off = Number(faixa(estado.qtd).off) || 0;
    return Math.round(preco * (100 - off) / 100);
  }
  function precoAtual() {
    if (estado.tamanho) return estado.tamanho.preco;
    if (estado.cor && estado.cor.tamanhos.length) return estado.cor.tamanhos[0].preco;
    return dados.tiers[0].unit;
  }
  function totalDoKit() {
    var soma = estado.pecas.reduce(function (a, p) { return a + noKit(p.preco); }, 0);
    if (estado.cor && estado.tamanho && estado.pecas.length < estado.qtd) soma += noKit(estado.tamanho.preco);
    return soma;
  }

  function medir(nome, extra) {
    var carga = Object.assign({ kit_qtd: estado.qtd }, extra || {});
    if (window.dataLayer) window.dataLayer.push(Object.assign({ event: nome }, carga));
    if (window.fbq) window.fbq('trackCustom', nome, carga);
  }

  /* ---------- montagem dos passos ---------- */

  function pintarCores() {
    el.cores.innerHTML = '';
    dados.cores.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kitw__swatch' + (estado.cor && estado.cor.handle === c.handle ? ' is-on' : '');
      b.title = c.nome;
      b.setAttribute('aria-label', c.nome);
      b.setAttribute('aria-pressed', estado.cor && estado.cor.handle === c.handle ? 'true' : 'false');
      var hex = hexPorCor[String(c.nome).trim().toLowerCase()];
      if (hex) {
        b.classList.add('kitw__swatch--cor');
        b.style.background = hex;
      } else {
        b.innerHTML = '<img src="' + c.foto + '" alt="" width="40" height="40" loading="lazy">';
      }
      b.addEventListener('click', function () {
        estado.cor = c;
        estado.tamanho = null;
        pintarCores();
        pintarTamanhos();
        atualizarCabecalho();
        atualizarBotao();
      });
      el.cores.appendChild(b);
    });
  }

  function pintarTamanhos() {
    el.tamanhos.innerHTML = '';
    if (!estado.cor) {
      el.tamanhos.innerHTML = '<p class="kitw__hint">Escolha a cor primeiro.</p>';
      return;
    }
    estado.cor.tamanhos.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kitw__size' + (estado.tamanho && estado.tamanho.id === t.id ? ' is-on' : '');
      b.textContent = t.nome;
      b.disabled = !t.disponivel;
      if (!t.disponivel) b.title = 'Esgotado';
      b.addEventListener('click', function () {
        estado.tamanho = t;
        pintarTamanhos();
        atualizarCabecalho();
        atualizarBotao();
      });
      el.tamanhos.appendChild(b);
    });
  }

  /* Preço no pix: só aparece quando o checkout realmente dá o desconto (pixOff > 0). */
  var pixOff = Number(dados.pixOff) || 0;
  function comPix(centavos) {
    return pixOff > 0 ? Math.round(centavos * (100 - pixOff) / 100) : centavos;
  }

  function atualizarCabecalho() {
    var f = faixa(estado.qtd);
    el.passo.textContent = 'Passo ' + (estado.indice + 1) + ' de ' + estado.qtd + ': Escolha suas peças';
    el.barra.style.width = Math.round(((estado.indice) / estado.qtd) * 100) + '%';
    el.unit.textContent = moeda(comPix(noKit(precoAtual())));
    if (el.pix) el.pix.hidden = pixOff <= 0;
    el.cheio.textContent = moeda(precoAtual());
    el.cheio.hidden = !(Number(f.off) > 0);
    if (estado.cor) {
      el.thumb.src = estado.cor.img;
      el.nome.textContent = estado.cor.titulo;
      el.corNome.textContent = estado.cor.nome;
    }
  }

  function atualizarBotao() {
    var ultimo = estado.indice === estado.qtd - 1;
    el.proximo.disabled = !(estado.cor && estado.tamanho);
    el.proximo.textContent = ultimo
      ? 'Adicionar kit ao carrinho — ' + moeda(comPix(totalDoKit()))
      : 'Ir para próximo item →';
  }

  function pintarResumo() {
    if (!estado.pecas.length) { el.resumo.hidden = true; return; }
    el.resumo.hidden = false;
    el.resumo.innerHTML = '<p class="kitw__resumo-t">Peças escolhidas</p>' +
      estado.pecas.map(function (p, i) {
        return '<span class="kitw__chip">' + (i + 1) + '. ' + p.corNome + ' · ' + p.tamanhoNome +
          '<button type="button" class="kitw__chip-x" data-kitw-remove="' + i + '" aria-label="Remover">×</button></span>';
      }).join('');
    el.resumo.querySelectorAll('[data-kitw-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        estado.pecas.splice(parseInt(b.getAttribute('data-kitw-remove'), 10), 1);
        estado.indice = estado.pecas.length;
        estado.cor = null;
        estado.tamanho = null;
        render();
      });
    });
  }

  function render() {
    pintarCores();
    pintarTamanhos();
    atualizarCabecalho();
    atualizarBotao();
    pintarResumo();
  }

  /* ---------- tiers ---------- */

  raiz.querySelectorAll('[data-kitw-tier]').forEach(function (b) {
    b.addEventListener('click', function () {
      var q = parseInt(b.getAttribute('data-kitw-tier'), 10);
      raiz.querySelectorAll('[data-kitw-tier]').forEach(function (o) {
        o.classList.toggle('is-on', o === b);
        o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
      });
      estado.qtd = q;
      estado.indice = 0;
      estado.pecas = [];
      estado.cor = null;
      estado.tamanho = null;
      el.erro.hidden = true;

      /* Com o kit aberto, o fluxo de 1 peça (cor, tamanho e botão de comprar) some — igual à Fábrica.
         O CSS esconde pelos seletores de body.kitw-aberto. */
      document.body.classList.toggle('kitw-aberto', q > 1);
      if (q === 1) {
        el.painel.hidden = true;   // volta pro fluxo normal do produto
        return;
      }
      el.painel.hidden = false;
      render();
      medir('kit_abriu');
    });
  });

  /* ---------- avançar / finalizar ---------- */

  el.proximo.addEventListener('click', function () {
    if (!estado.cor || !estado.tamanho) return;
    estado.pecas.push({
      id: estado.tamanho.id,
      preco: estado.tamanho.preco,
      corNome: estado.cor.nome,
      tamanhoNome: estado.tamanho.nome
    });
    estado.cor = null;
    estado.tamanho = null;

    if (estado.pecas.length < estado.qtd) {
      estado.indice = estado.pecas.length;
      render();
      medir('kit_proxima_peca', { peca: estado.indice + 1 });
      return;
    }
    adicionar();
  });

  /* Depois de adicionar: abre a gaveta lateral do tema em vez de ir pra /cart.
     O tema recarrega o conteúdo com theme:cart:change e abre com theme:cart-drawer:show.
     Se a loja estiver sem gaveta (window.theme.hasCartDrawer falso), aí sim navega. */
  function abrirGaveta() {
    var temGaveta = !!(window.theme && window.theme.hasCartDrawer) || !!document.querySelector('cart-drawer');
    if (!temGaveta) {
      window.location.href = window.Shopify.routes.root + 'cart';
      return;
    }
    // <cart-items> é quem busca /cart?section_id=api-cart-items e redesenha a gaveta
    var itens = document.querySelector('cart-items');
    if (itens && typeof itens.getCart === 'function') itens.getCart();

    document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
    var gaveta = document.querySelector('cart-drawer');
    if (gaveta) gaveta.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));

    // volta o kit ao estado inicial pra próxima montagem
    estado.pecas = [];
    estado.indice = 0;
    estado.cor = null;
    estado.tamanho = null;
    render();
  }

  function adicionar() {
    el.proximo.disabled = true;
    el.proximo.textContent = 'Adicionando...';
    el.erro.hidden = true;

    // agrupa peças iguais numa linha só, pro carrinho não repetir a mesma variante
    var linhas = {};
    estado.pecas.forEach(function (p) { linhas[p.id] = (linhas[p.id] || 0) + 1; });

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: Object.keys(linhas).map(function (id) {
          return { id: parseInt(id, 10), quantity: linhas[id] };
        })
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, corpo: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.corpo.description || res.corpo.message || 'Não foi possível adicionar.');
        medir('kit_adicionado', { valor: totalDoKit() / 100 });
        abrirGaveta();
      })
      .catch(function (e) {
        el.erro.textContent = e.message;
        el.erro.hidden = false;
        el.proximo.disabled = false;
        atualizarBotao();
      });
  }
})();
